<script>
import Layout from "@layouts/form";
import Cliente from "@forms/Cliente";

export default {
  page: {
    title: "Detalhes | Cliente"
  },
  components: { Layout, Cliente },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Cliente",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Cliente",
          href: "/Cliente"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <Cliente :editable="editable"></Cliente>
    </div>
  </Layout>
</template>
